export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-complete@4x-f8e7ead4d99c76153dee61ade54bb859.webp";